import AreaChart from "../../../../components/areaChart/areaChart";
import { connect } from "react-redux";
export default connect(state => ({
  chartData: state.membership.yearOverYearMembershipRevenue.revenuesYearOverYearComparison,
  width: 675,
  currencySymbol: state.membership.yearOverYearMembershipRevenue.currencySymbol
}))(AreaChart);
